import { DashboardService } from "@/clients/services/DashboardService";
import { QueryKeys } from "@/constants/query-keys";
import { QueryStaleTime } from "@/constants/query-stale-time";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetDashboardMessages = () => {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: [QueryKeys.DASHBOARD_MESSAGES],
    staleTime: QueryStaleTime.SHORT,
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } = await DashboardService.getDashboardMessagesApiV1DashboardMessagesGet(
        user.id,
      );
      return data;
    },
  });

  return { dashboardMessages: data, isLoading, isError, error, refetch };
};
